import { createApp } from 'vue'
import { createI18n } from 'vue-i18n';

import App from './App.vue';

const i18n = createI18n({
  //locale: window.location.pathname.includes('/en/') ? 'en' : 'cs',
  locale: 'cs',
  fallbackLocale: 'cs',
  messages: window.aboutUs.translations,
});

const app = createApp(App);

app.use(i18n);

app.mount('#about-us-app')
